export default "__VITE_ASSET__9dda7da5__"